module.exports = __webpack_public_path__ + "img/mobile-empty.7d6b212c.png";